import React, { Fragment } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';

import {
    Typography, Divider, ListItem,
    ListItemText, ListItemIcon, Avatar, Link
} from '@mui/material';
import eventIcons from '../../utils/eventIcons.js';

import {
    setHighlightedEvent, removeHighlightedEvent,
    highlightedEventSelector
} from '../../features/datacenter/historySlice.js';
import { setCenter, setZoom } from '../../features/map/mapSlice';


const TimeLineEventItem = ({ data, track }) => {
    const dispatch = useDispatch();
    const highlightedEvent = useSelector(highlightedEventSelector);
    const thisEventHighlighted = highlightedEvent.routeIndex === data.routeIndex;
    const highlightEventCallback = () => {
        if (thisEventHighlighted) {
            dispatch(removeHighlightedEvent());
        } else {
            dispatch(setHighlightedEvent({
                routeIndex: data.routeIndex
            }));
            dispatch(setCenter({
                /* lat: track[data.routeIndex].lat,
                lng: track[data.routeIndex].lng, */
                lat: data.lat,
                lng: data.lng
            }));
            dispatch(setZoom(17));
        }
    }
    return (
        <div>
            <ListItem key={data.event_id} style={{ backgroundColor: thisEventHighlighted ? 'Beige' : 'white' }}>
                <ListItemIcon>
                    <Avatar style={{ backgroundColor: 'White' }}>
                        {eventIcons(data.event_type || data.event_desc)}
                    </Avatar>
                </ListItemIcon>
                <ListItemText
                    primary={
                        <Fragment>
                            <Link href="#" onClick={highlightEventCallback}>
                                <Typography variant="subtitle2">
                                    <b>{data.event_type || data.event_desc}</b>
                                </Typography>
                            </Link>
                            {moment(data.event_time).format('D/M/Y h:mm A')}
                        </Fragment>
                    }
                    /* secondary={track[data.routeIndex].address ? track[data.routeIndex].address.net_addr : ''} */
                    secondary={data.address ? data.address.net_addr : ''}
                />
            </ListItem>
            <Divider />
        </div>
    );
}

export default TimeLineEventItem;